module.exports = __webpack_public_path__ + "media/images/new_home/facebook-icon-de9ad58c123ebf3f3aa718cad6bc7c2b.png";